import React, { useEffect, useState } from 'react';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../core/Firebase';
import Login from './Login';

// Blocks the whole app behind the login page until Firebase confirms a signed-in
// user. Actual authorization (is this account allowed to touch the admin API) is
// enforced server-side by is-admin.middleware.ts — this only gates the UI.
const AuthGuard = ({ children }) => {
    const [ready, setReady] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = onIdTokenChanged(auth, (nextUser) => {
            setUser(nextUser);
            setReady(true);
        });

        return unsubscribe;
    }, []);

    if (!ready) {
        return (
            <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 text-white text-sm" data-theme="sentinel">
                Loading…
            </div>
        );
    }

    if (!user) {
        return <Login />;
    }

    return children;
};

export default AuthGuard;
